import { Column, Row } from '@simplywallst/ui-core';
import { IncomeDetails } from './components/IncomeDetails';
import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';
import loadable from '@loadable/component';
import { COMPANY_INCOME_STATEMENT } from '@/constants/feedbackSections';
import IncomeTable from './components/IncomeTable';
import { ColumnWithMargin, Header } from './styled';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

const IncomeWaterfall = loadable(() => import('./components/IncomeWaterfall'), {
  resolveComponent: (component) => component.IncomeWaterfall,
});

export function IncomeStatement() {
  const t = useOverviewTranslation();
  return (
    <>
      <Row>
        <ColumnWithMargin colMd={6} colSm={12}>
          <Header data-cy-id="income-statement">
            {t('fundamentals.income.chart.heading')}
          </Header>
          <ChartWrapper
            id="overview-income-statement"
            chart={<IncomeWaterfall />}
            table={<IncomeTable />}
            preRenderHeight={248}
            actionsMarginTop={16}
            feedbackLabel={COMPANY_INCOME_STATEMENT}
          />
        </ColumnWithMargin>
        <Column colMd={6} colSm={12}>
          <IncomeDetails />
        </Column>
      </Row>
    </>
  );
}
